// Core Modules
import { Component, inject, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';

// External Modules
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';

// Models
import { IHomeCard } from '@home/models/card-model';

// Enums
import { MainNavigationEnum } from '@shared/enum/main-navigation-url.enum';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  standalone: true,
  imports: [NgxPermissionsModule, RouterLink],
})
export class HomeComponent implements OnInit {
  // Injectors
  private readonly ngxPermissionsService = inject(NgxPermissionsService);

  // Public Members
  public allowDisplay: boolean = false;
  public cardConfig: IHomeCard[] = [];

  public ngOnInit(): void {
    Promise.all([this.ngxPermissionsService.hasPermission('token-read'), this.ngxPermissionsService.hasPermission('user-read')]).then((result: boolean[]) => {
      const [token, user] = result;
      this.allowDisplay = token || user;
      if (this.allowDisplay)
        this.cardConfig.push(
          {
            title: 'Token Management',
            src: '/assets/images/consumer-profiler-report-bg.png',
            description: `Allow users to view and create their own authenticated API Tokens.`,
            goto: `/${MainNavigationEnum.API_TOKENS}`,
            permissionOnly: 'token-read',
          },
          {
            title: 'User Management',
            src: '/assets/images/report_icon.svg',
            description: `Allow admins to view and modify user access.This includes managing roles and scopes and providing authenticated access to different clients.`,
            goto: `/${MainNavigationEnum.USER_MANAGEMENT}`,
            permissionOnly: 'user-read',
          }
        );
    });
  }
}
